import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import chooseDept from "../chooseDept/index.vue";
import setEmployeeArea from "../setEmployeeArea/index.vue";
import $http from '$http';

export default {
    mixins: [services],
    components: {
        chooseDept,
        setEmployeeArea
    },
    props: {},
    created() {},
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            title: '',
            lists: [],
            query: this.getQuery(),
            sel: []
        }
    },
    methods: {
        getQuery() {
            return cloneDeep({
                deptId: 151,
                d_name: '',
                userName: '',
                status: '正式员工,试用期',
            });
        },
        show(opts) {
            this.query = this.getQuery();
            this.AddDialogVisible = true
            this.title = opts.title
            this.getList()
        },
        getDeptData(item) {
            this.query.deptId = item.Id
            this.query.d_name = item.D_Name
            this.getList()
        },
        // 选择项
        handleSelectionChange(sel) {
            //console.log(sel)
            this.sel = sel
        },
        // 选择部门
        chooseDept() {
            this.$refs.refsChooseDept.show({})
        },
        //查询
        onQuerySubmit: function () {
            this.pageIndex = 1;
            this.getList();
        },
        // 重置
        onQueryClean: function () {
            this.query = this.getQuery();
            this.getList();
        },
        //分页
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },
        // 提交
        submit() {
            if (this.sel.length > 0) {
                this.$refs.refSetEmployeeArea.show({
                    dataList: this.sel
                })
            } else {
                this.$notify({
                    title: '警告',
                    message: '选择业务员！',
                    type: 'warning'
                });
            }

        },
        //取消
        close() {
            this.AddDialogVisible = false
            this.$emit('getTableList')
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/addEmployeeDialog/vm.js